export const IGNORED_SENTRY_ERRORS = [
  'Non-Error promise rejection captured',
  /Object captured as promise rejection with keys/,
  /undefined is not an object \(evaluating '(n\.length|e\.img|i\.state|this\.currentStepObj\.(camera|configs)|o\.path\.length)'\)/,
  /initAutocomplete is not a function/,
  /Failed to fetch/,
  /AbortError: The operation was aborted/,
  /Error: no available backend found\. ERR:/,
  /Invalid call to runtime\.sendMessage\(\)\. Tab not found\./,
  /Could not load "(places_impl|places|util)"/,
  /null is not an object (evaluating 'document.elementFromPoint(\d+.\d+, \d+.\d+).click')/,
  /Cannot read properties of null \(reading '(parentElement|classList|getBoundingClientRect)'\)/,
  /Cannot read properties of undefined \(reading '(type|camera|fireEvent|audioVolumeChange|setScreenSize|fireChangeEvent|setDefaultPosition|setCurrentPosition|fireReadyEvent|setMaxSize|img|heightCoefficient)'\)/,
  /Cannot read property '(fireEvent|fireReadyEvent|setCurrentPosition|setDefaultPosition|fireChangeEvent|setMaxSize|setScreenSize|audioVolumeChange|setIsViewable)' of undefined/,
  /Can't find variable: (Chartboost|HTMLDialogElement|gmo)/,
];
